import Notifications from '@components/ItemPage/Details/Notifications'
import Information from '@components/ItemPage/Details/Information'
import Important from '@components/ItemPage/Details/Important'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'

const Details = () => {
  const { itemState } = useItemPage()

  const { title } = itemState

  if (!title) return <></>

  return (
    <div className="bg-white w-full">
      <div className="px-4">
        <Important />
        <Notifications />
        <Information />
      </div>
    </div>
  )
}

export default Details
